import { useContext } from 'react'
import { ToastContext } from './toastContext'
import type { ToastContextValue } from './toastTypes'

export function useToast(): ToastContextValue {
  const context = useContext(ToastContext)
  if (!context) {
    throw new Error('useToast must be used within a ToastProvider')
  }
  return context
}
